import React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import Icon from '@material-ui/core/Icon';

// Menu Home
import HomePage from 'containers/Pages/HomeMenu/HomePage/Loadable';

// Menu Dashboard
import DashboardPage from 'containers/Pages/DashboardMenu/HomePage/Loadable';
import DashboardTimeLinePage from 'containers/Pages/DashboardMenu/TimelinePage/Loadable';

// Menu Pedidos
// import OrderListPage from 'containers/Pages/OrderMenu/ListPage/Loadable';
// import OrderViewPage from 'containers/Pages/OrderMenu/ViewPage/Loadable';

// // Menu Cash
// import CashExpressPage from 'containers/Pages/CashExpressMenu/Loadable';

// // Menu Catalogo Virtual
// import VirtualCatalogListPage from 'containers/Pages/VirtualCatalogMenu/ListPage/Loadable';
// import VirtualCatalogInsertPage from 'containers/Pages/VirtualCatalogMenu/InsertPage/Loadable';
// import VirtualCatalogUpdatePage from 'containers/Pages/VirtualCatalogMenu/UpdatePage/Loadable';

// // Menu Produtos
// import CatalogProductListPage from 'containers/Pages/CatalogMenu/ProductListPage/Loadable';
// import CatalogProductInsertPage from 'containers/Pages/CatalogMenu/ProductInsertPage/Loadable';
// import CatalogProductUpdatePage from 'containers/Pages/CatalogMenu/ProductUpdatePage/Loadable';
// import CatalogProductImportPage from 'containers/Pages/CatalogMenu/StockPage/Loadable';
// import CatalogColorListPage from 'containers/Pages/CatalogMenu/ColorListPage/Loadable';
// import CatalogColorInsertPage from 'containers/Pages/CatalogMenu/ColorInsertPage/Loadable';
// import CatalogColorUpdatePage from 'containers/Pages/CatalogMenu/ColorUpdatePage/Loadable';
// import CatalogSizeListPage from 'containers/Pages/CatalogMenu/SizeListPage/Loadable';
// import CatalogSizeInsertPage from 'containers/Pages/CatalogMenu/SizeInsertPage/Loadable';
// import CatalogSizeUpdatePage from 'containers/Pages/CatalogMenu/SizeUpdatePage/Loadable';
// import CatalogKitListPage from 'containers/Pages/CatalogMenu/KitListPage/Loadable';
// import CatalogKitInsertPage from 'containers/Pages/CatalogMenu/KitInsertPage/Loadable';
// import CatalogKitUpdatePage from 'containers/Pages/CatalogMenu/KitUpdatePage/Loadable';
// import CatalogCategoryListPage from 'containers/Pages/CatalogMenu/CategoryListPage/Loadable';
// import CatalogCategoryInsertPage from 'containers/Pages/CatalogMenu/CategoryInsertPage/Loadable';
// import CatalogCategoryUpdatePage from 'containers/Pages/CatalogMenu/CategoryUpdatePage/Loadable';

// Menu configurações de Loja

// Menu Lojas
// import StoreListPage from 'containers/Pages/StoreMenu/ListPage/Loadable';
// import StoreInsertPage from 'containers/Pages/StoreMenu/InsertPage/Loadable';
// import StoreUpdatePage from 'containers/Pages/StoreMenu/UpdatePage';

// Menu Responsáveis
import ClientListPage from 'containers/Pages/ClientMenu/ListPage/Loadable';
import SonListPage from 'containers/Pages/ClientMenu/SonListPage/Loadable';
// import ClientProfileListPage from 'containers/Pages/ClientMenu/ProfileListPage/Loadable';
// import ClientProfileInsertPage from 'containers/Pages/ClientMenu/ProfileInsertPage/Loadable';
import ClientViewPage from 'containers/Pages/ClientMenu/ViewPage';
import ClientUpdate from 'containers/Pages/ClientUpdate';
// import NewsletterPage from 'containers/Pages/ClientMenu/NewsletterPage/Loadable';

// Menu Relatórios
// import SalePage from 'containers/Pages/ReportMenu/SalePage/Loadable';
// import SaleByCategoryPage from 'containers/Pages/ReportMenu/SaleByCategoryPage/Loadable';
// import ProductAndStockPage from 'containers/Pages/ReportMenu/ProductAndStockPage/Loadable';

// Menu Marketing

import BannerListPage from 'containers/Pages/MarketingMenu/BannerListPage/Loadable';
import BannerInsertPage from 'containers/Pages/MarketingMenu/BannerInsertPage/Loadable';
import BannerUpdatePage from 'containers/Pages/MarketingMenu/BannerUpdatePage/Loadable';
// import TrendListPage from 'containers/Pages/MarketingMenu/TrendListPage/Loadable';
// import TrendInsertPage from 'containers/Pages/MarketingMenu/TrendInsertPage/Loadable';
// import TrendUpdatePage from 'containers/Pages/MarketingMenu/TrendUpdatePage/Loadable';
// import ScrollListPage from 'containers/Pages/MarketingMenu/ScrollListPage/Loadable';
// import ScrollInsertPage from 'containers/Pages/MarketingMenu/ScrollInsertPage/Loadable';
// import ScrollUpdatePage from 'containers/Pages/MarketingMenu/ScrollUpdatePage/Loadable';

// Menu Promoções

// import CouponListPage from 'containers/Pages/PromotionMenu/CouponListPage/Loadable';
// import CouponInsertPage from 'containers/Pages/PromotionMenu/CouponInsertPage/Loadable';
// import CouponUpdatePage from 'containers/Pages/PromotionMenu/CouponUpdatePage/Loadable';

// Menu usuários
import UserListPage from 'containers/Pages/UserMenu/ListPage/Loadable';
import UserNewPage from 'containers/Pages/UserMenu/InsertPage/Loadable';
import UserUpdatePage from 'containers/Pages/UserMenu/UpdatePage/Loadable';

// Menu Configurações
import SettingsGeneralConfigPage from 'containers/Pages/SettingMenu/GeneralConfigPage/Loadable';
// import ProfileAccessListPage from 'containers/Pages/SettingMenu/ProfileAccessListPage/Loadable';
// import ProfileAccessInsertPage from 'containers/Pages/SettingMenu/ProfileAccessInsertPage/Loadable';

// Menu Página
// import PageListPage from 'containers/Pages/PageMenu/ListPage/Loadable';
// import PageInsertPage from 'containers/Pages/PageMenu/InsertPage/Loadable';
// import PageUpdatePage from 'containers/Pages/PageMenu/UpdatePage/Loadable';

// Menu Módulos

import ModuleListPage from 'containers/Pages/ModuleMenu/ListPage/Loadable';
import ModuleCategoryListPage from 'containers/Pages/ModuleMenu/CategoryListPage/Loadable';
import ModuleCategoryInsertPage from 'containers/Pages/ModuleMenu/CategoryInsertPage/Loadable';
import ModuleCategoryUpdatePage from 'containers/Pages/ModuleMenu/CategoryUpdatePage/Loadable';
// import AttachmentModule from 'containers/Pages/ModuleMenu/AttachmentModule/Loadable';
import ModuleInsertPage from 'containers/Pages/ModuleMenu/InsertPage/Loadable';
import ModuleUpdatePage from 'containers/Pages/ModuleMenu/UpdatePage/Loadable';
import ActivityListPage from 'containers/Pages/ModuleMenu/ActivityListPage/Loadable';
import ActivityInsertPage from 'containers/Pages/ModuleMenu/ActivityInsertPage/Loadable';
import ActivityUpdatePage from 'containers/Pages/ModuleMenu/ActivityUpdatePage/Loadable';
import AttachmentListPage from 'containers/Pages/ModuleMenu/AttachmentListPage/Loadable';
import AttachmentInsertPage from 'containers/Pages/ModuleMenu/AttachmentInsertPage/Loadable';
import AttachmentInsertPageModule from 'containers/Pages/ModuleMenu/AttachmentInsertPageModule/Loadable';
import AttachmentUpdatePage from 'containers/Pages/ModuleMenu/AttachmentUpdatePage/Loadable';
import AttachmentUpdatePageModule from 'containers/Pages/ModuleMenu/AttachmentUpdatePageModule/Loadable';

// Menu Blog
import BlogCategoryListPage from 'containers/Pages/BlogMenu/CategoryListPage/Loadable';
import BlogCategoryInsertPage from 'containers/Pages/BlogMenu/CategoryInsertPage/Loadable';
import BlogCategoryUpdatePage from 'containers/Pages/BlogMenu/CategoryUpdatePage/Loadable';
import BlogPostListPage from 'containers/Pages/BlogMenu/PostListPage/Loadable';
import BlogPostInsertPage from 'containers/Pages/BlogMenu/PostInsertPage/Loadable';
import BlogPostUpdatePage from 'containers/Pages/BlogMenu/PostUpdatePage/Loadable';

// Group
import GroupListPage from 'containers/Pages/GroupPage/GroupListPage';
import GroupChildInsertPage from 'containers/Pages/GroupPage/GroupInsertPage';
import GroupChildUpdatePage from 'containers/Pages/GroupPage/GroupUpdatePage';

import InterestListPage from 'containers/Pages/InterestPage/InterestListPage';
import InterestInsertPage from 'containers/Pages/InterestPage/InterestInsertPage';
import InterestUpdatePage from 'containers/Pages/InterestPage/InterestUpdatePage';

// Páginas gerais
import NotFoundPage from 'containers/NotFoundPage/Loadable';
import ChildrenViewPage from 'containers/Pages/ClientMenu/ChildrenViewPage';
import MyUser from 'containers/Pages/UserMenu/MyUser';
import TermsPage from 'containers/Pages/SettingMenu/TermsPage';
import PrivacyPolitiesPage from 'containers/Pages/SettingMenu/PrivacyPolitiesPage';

import MailConfirmPage from 'containers/Pages/MailConfirmPage';

import PublicTermsPage from 'containers/Pages/PublicTermsPage';
import PublicPrivacyPolities from 'containers/Pages/PublicPrivacyPolities';

import AuthPage from 'containers/Auth';

// Menu tree
const Menu = [
  {
    id: 'home',
    text: 'Home',
    icon: <Icon>home</Icon>,
    url: '/',
    component: HomePage,
  },
  {
    id: 'dashboard',
    text: 'Dashboard',
    icon: <Icon>timeline</Icon>,
    component: DashboardPage,
    isDynamic: true,
    children: [
      {
        id: 'dashboard-info',
        text: 'Dashboard',
        url: '/dashboard',
        component: DashboardPage,
        showInMenu: false,
      },
      {
        id: 'dashboard-timeline',
        text: 'Timeline',
        url: '/dashboard/:userId/timeline',
        component: DashboardTimeLinePage,
        showInMenu: false,
      },
    ],
  },

  {
    id: 'module',
    text: 'Módulos',
    icon: <Icon>account_balance</Icon>,
    children: [
      {
        id: 'modules-module-list',
        text: 'Listar Módulos',
        url: '/modulos',
        component: ModuleListPage,
        showInMenu: true,
      },
      // {
      //   id: 'modules-module-list-attachment',
      //   text: 'Listar Anexos do Módulo',
      //   url: '/modulos/:id/anexos',
      //   component: AttachmentModule,
      //   showInMenu: false,
      // },
      {
        id: 'modules-module-insert',
        text: 'Novo Módulo',
        url: '/modulos/novo',
        component: ModuleInsertPage,
        showInMenu: true,
      },
      {
        id: 'modules-category-list',
        text: 'Categorias',
        url: '/modulos/categories',
        component: ModuleCategoryListPage,
      },
      {
        id: 'modules-category-new',
        text: 'Cadastrar Categoria',
        url: '/modulos/categories/new',
        component: ModuleCategoryInsertPage,
        showInMenu: false,
      },
      {
        id: 'modules-category-update',
        text: 'Atualizar Categoria',
        url: '/modulos/categories/update/:id',
        component: ModuleCategoryUpdatePage,
        showInMenu: false,
      },
      {
        id: 'modules-module-update',
        text: 'Editar Módulo',
        url: '/modulos/:id/editar',
        component: ModuleUpdatePage,
        showInMenu: false,
      },
      {
        id: 'activities-module-list',
        text: 'Listar Atividades',
        url: '/modulos/:moduleId/atividades',
        component: ActivityListPage,
        showInMenu: false,
      },
      {
        id: 'activities-module-insert',
        text: 'Nova Atividade',
        url: '/modulos/:moduleId/atividades/novo',
        component: ActivityInsertPage,
        showInMenu: false,
      },
      {
        id: 'activities-module-update',
        text: 'Alterar Atividade',
        url: '/modulos/:moduleId/atividades/:activityId/editar',
        component: ActivityUpdatePage,
        showInMenu: false,
      },
      {
        id: 'attachment-module-list',
        text: 'Listar Anexos',
        url: '/modulos/:moduleId/atividades/:activityId/anexos',
        component: AttachmentListPage,
        showInMenu: false,
      },
      {
        id: 'attachment-module-insert',
        text: 'Novo Anexo',
        url: '/modulos/:moduleId/atividades/:activityId/anexos/novo',
        component: AttachmentInsertPage,
        showInMenu: false,
      },
      {
        id: 'attachment-bymodule-insert',
        text: 'Novo Anexo',
        url: '/modulos/:moduleId/anexos/novo',
        component: AttachmentInsertPageModule,
        showInMenu: false,
      },
      {
        id: 'attachment-module-update',
        text: 'Editar Anexo',
        url:
          '/modulos/:moduleId/atividades/:activityId/anexos/:attachmentId/editar',
        component: AttachmentUpdatePage,
        showInMenu: false,
      },
      {
        id: 'attachment-bymodule-update',
        text: 'Editar Anexo',
        url: '/modulos/:moduleId/anexos/:attachmentId/editar',
        component: AttachmentUpdatePageModule,
        showInMenu: false,
      },
    ],
  },
  {
    id: 'marketing',
    text: 'Banners',
    icon: <Icon>image</Icon>,
    children: [
      {
        id: 'marketing-banner-list',
        text: 'Listar Banner',
        url: '/marketing/banners',
        component: BannerListPage,
      },
      {
        id: 'marketing-banner-new',
        text: 'Cadastrar Banner',
        url: '/marketing/banners/new',
        component: BannerInsertPage,
        showInMenu: true,
      },
      {
        id: 'marketing-banner-update',
        text: 'Atualizar banner',
        url: '/marketing/banners/update/:id',
        component: BannerUpdatePage,
        showInMenu: false,
      },
    ],
  },
  {
    id: 'blog',
    text: 'Blog',
    icon: <Icon>list</Icon>,
    children: [
      {
        id: 'blog-post-list',
        text: 'Posts',
        url: '/blog/posts',
        component: BlogPostListPage,
      },
      {
        id: 'blog-post-new',
        text: 'Cadastrar Post',
        url: '/blog/posts/new',
        component: BlogPostInsertPage,
        showInMenu: false,
      },
      {
        id: 'blog-post-update',
        text: 'Atualizar Post',
        url: '/blog/posts/update/:id',
        component: BlogPostUpdatePage,
        showInMenu: false,
      },
      {
        id: 'blog-category-list',
        text: 'Categorias',
        url: '/blog/categories',
        component: BlogCategoryListPage,
      },
      {
        id: 'blog-category-new',
        text: 'Cadastrar Categoria',
        url: '/blog/categories/new',
        component: BlogCategoryInsertPage,
        showInMenu: false,
      },
      {
        id: 'blog-category-update',
        text: 'Atualizar Categoria',
        url: '/blog/categories/update/:id',
        component: BlogCategoryUpdatePage,
        showInMenu: false,
      },
    ],
  },
  {
    id: 'client',
    text: 'Famílias',
    icon: <Icon>home</Icon>,
    children: [
      {
        id: 'client-list',
        text: 'Listar Responsáveis',
        url: '/clients',
        component: ClientListPage,
      },
      {
        id: 'son-list',
        text: 'Listar filhos',
        url: '/son',
        component: SonListPage,
      },
      {
        id: 'client-view',
        text: 'Visualizar cliente',
        url: '/clients/view/:clientId',
        component: ClientViewPage,
        showInMenu: false,
      },
      {
        id: 'children-view',
        text: 'Visualizar cliente',
        url: '/client/view/:clientId/children/view/:childrenId',
        component: ChildrenViewPage,
        showInMenu: false,
      },
      {
        id: 'client-update',
        text: 'Atualizar cliente',
        url: '/client/update/:id',
        component: ClientUpdate,
        showInMenu: false,
      },
      {
        id: 'group-list',
        text: 'Listar Grupos',
        url: '/groups',
        component: GroupListPage,
      },
      {
        id: 'group-child-new',
        text: 'Cadastrar Grupo',
        url: '/groups/new',
        component: GroupChildInsertPage,
        showInMenu: false,
      },
      {
        id: 'group-child-update',
        text: 'Atualizar Grupo',
        url: '/groups/update/:id',
        component: GroupChildUpdatePage,
        showInMenu: false,
      },
      {
        id: 'interest-list',
        text: 'Listar Interesses',
        url: '/interests',
        component: InterestListPage,
      },
      {
        id: 'interest-new',
        text: 'Cadastrar Interesse',
        url: '/interests/new',
        component: InterestInsertPage,
        showInMenu: false,
      },
      {
        id: 'interest-update',
        text: 'Atualizar Interesses',
        url: '/interests/update/:id',
        component: InterestUpdatePage,
        showInMenu: false,
      },
    ],
  },
  {
    id: 'user',
    text: 'Usuários',
    icon: <Icon>people_alt</Icon>,
    children: [
      {
        id: 'user-list',
        text: 'Listar Usuário',
        url: '/users',
        component: UserListPage,
      },
      {
        id: 'user-new',
        text: 'Cadastrar Usuário',
        url: '/users/new',
        component: UserNewPage,
      },
      {
        id: 'user-update',
        text: 'Atualizar Usuário',
        url: '/users/update/:id',
        component: UserUpdatePage,
        showInMenu: false,
      },
    ],
  },
  {
    id: 'config',
    text: 'Configurações',
    icon: <Icon>settings</Icon>,
    children: [
      {
        id: 'general-config',
        text: 'Configurações gerais',
        url: '/config',
        component: SettingsGeneralConfigPage,
      },
      {
        id: 'general-profile',
        text: 'Meu Perfil',
        url: '/myuser/:id',
        component: MyUser,
        showInMenu: false,
      },
      {
        id: 'general-terms',
        text: 'Termos de Uso',
        url: '/terms-and-conditions',
        component: TermsPage,
        showInMenu: true,
      },
      {
        id: 'politicies-terms',
        text: 'Politicas de Privacidade',
        url: '/privacy-polities',
        component: PrivacyPolitiesPage,
        showInMenu: true,
      },
    ],
  },
  {
    id: 'mail-confirm',
    url: '/minha-conta/confirmar',
    component: MailConfirmPage,
    showInMenu: false,
    pagePublic: true,
  },
  {
    id: 'public-terms',
    url: '/termos-e-condicoes',
    component: PublicTermsPage,
    showInMenu: false,
    pagePublic: true,
  },
  {
    id: 'privacy-policies',
    url: '/politicas-de-privacidade',
    component: PublicPrivacyPolities,
    showInMenu: false,
    pagePublic: true,
  },
];

// Asign index and parent fields for each item, which is needed for header tabs navigation
let index = 0;

Menu.map(item => {
  const menuItem = item;
  menuItem.index = index;
  index += 1;
  if (menuItem.children) {
    menuItem.children.map(child => {
      const childItem = child;

      childItem.index = index;
      childItem.parent = {
        id: childItem.id,
        parentId: menuItem.id,
        parentText: menuItem.text,
      };
      index += 1;

      return child;
    });
  }
  return item;
});

// Routes
const getRoute = item => (
  <Route key={item.id} exact path={item.url} component={item.component} />
);

const Routes = (location, dynamicMenu, pagePublic = false) => {
  // eslint-disable-next-line no-console
  console.log({ pagePublic });
  const menu = dynamicMenu || Menu;
  return (
    <BrowserRouter forceRefresh>
      <Switch key={location.key} location={location}>
        {menu
          .filter(
            item =>
              (pagePublic && item.pagePublic) ||
              (!pagePublic && !item.pagePublic),
          )
          .map(item => {
            const menuReturnerd = !item.children
              ? getRoute(item)
              : item.children.map(child => getRoute(child));
            return menuReturnerd;
          })}
        <Route component={!pagePublic ? NotFoundPage : AuthPage} />
      </Switch>
    </BrowserRouter>
  );
};

export { Menu, Routes };
